import { Swiper } from './swiper-BHBZRieG.js';
import { N as Navigation } from './navigation-CK8lyTSb.js';
import { A as A11y } from './a11y-BuXkunhH.js';
import './utils-DCxzPGFN.js';

class BrandSlider extends HTMLElement {
  #swiper = this.querySelector('.swiper');
  #prevButton = this.querySelector('.swiper-prev');
  #nextButton = this.querySelector('.swiper-next');

  connectedCallback() {
    new Swiper(this.#swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 2,
      spaceBetween: 16,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      navigation: {
        prevEl: this.#prevButton,
        nextEl: this.#nextButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 5.5,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
      },
    });
  }
}

customElements.define('brand-slider', BrandSlider);
